// ─────────────────────────────────────────────────────────────────────────────
// AXIS360 DISC — Question Bank
// 28 forced-choice groups · Statement format · One per D/I/S/C
// Science: Marston (1928) · Assessments 24x
// Format: MOST like me / LEAST like me
// Note: Words are shuffled in DISCSurvey at render — order here is reference only
// ─────────────────────────────────────────────────────────────────────────────

export const DISC_GROUPS = [
  { id:1, words:[
    { w:"I prefer to tackle challenges directly and decisively",              dim:"D" },
    { w:"I like to brainstorm with others to find the best solution",         dim:"I" },
    { w:"I prefer to solve problems in a careful, step-by-step way",          dim:"S" },
    { w:"I like to thoroughly analyse a problem before taking action",        dim:"C" },
  ]},
  { id:2, words:[
    { w:"I set ambitious goals and push hard to achieve them",                dim:"D" },
    { w:"I find it easy to motivate and inspire the people around me",        dim:"I" },
    { w:"I am known for being reliable and consistent in my work",            dim:"S" },
    { w:"I take great care to ensure my work is accurate and thorough",       dim:"C" },
  ]},
  { id:3, words:[
    { w:"I say what I think directly, even if it creates tension",            dim:"D" },
    { w:"I enjoy conversations and making people feel comfortable",           dim:"I" },
    { w:"I listen carefully before sharing my own perspective",               dim:"S" },
    { w:"I prefer to communicate important matters in writing",               dim:"C" },
  ]},
  { id:4, words:[
    { w:"I take charge quickly when a situation changes suddenly",            dim:"D" },
    { w:"I get excited by new possibilities and fresh opportunities",         dim:"I" },
    { w:"I prefer change that is planned and introduced gradually",           dim:"S" },
    { w:"I evaluate change carefully before committing to it",                dim:"C" },
  ]},
  { id:5, words:[
    { w:"I drive meetings toward clear decisions and action",                 dim:"D" },
    { w:"I bring energy and enthusiasm to group discussions",                 dim:"I" },
    { w:"I create a comfortable, supportive environment in meetings",         dim:"S" },
    { w:"I come to meetings well-prepared with facts and data",               dim:"C" },
  ]},
  { id:6, words:[
    { w:"When under pressure, I become more determined and focused",          dim:"D" },
    { w:"When under pressure, I talk to people to process my thoughts",       dim:"I" },
    { w:"When under pressure, I stay calm and work through things steadily",  dim:"S" },
    { w:"When under pressure, I focus on getting every detail right",         dim:"C" },
  ]},
  { id:7, words:[
    { w:"I build networks that help me achieve my objectives",                dim:"D" },
    { w:"I genuinely enjoy getting to know people on a personal level",       dim:"I" },
    { w:"I invest in long-term, loyal relationships at work",                 dim:"S" },
    { w:"I choose my professional relationships carefully and selectively",   dim:"C" },
  ]},
  { id:8, words:[
    { w:"I am comfortable taking charge and giving clear direction",          dim:"D" },
    { w:"I motivate others by being enthusiastic and optimistic",             dim:"I" },
    { w:"I lead by supporting people and earning their trust steadily",       dim:"S" },
    { w:"I lead by setting high standards and modelling quality work",        dim:"C" },
  ]},
  { id:9, words:[
    { w:"I prefer to work at a fast pace and make quick progress",            dim:"D" },
    { w:"I enjoy working in a lively, social, collaborative environment",     dim:"I" },
    { w:"I prefer a steady, predictable pace of work",                        dim:"S" },
    { w:"I work at whatever pace is needed to ensure quality and accuracy",   dim:"C" },
  ]},
  { id:10, words:[
    { w:"I am comfortable taking bold risks to achieve important results",    dim:"D" },
    { w:"I trust that things will work out and embrace new opportunities",    dim:"I" },
    { w:"I prefer to take measured, low-risk approaches to new situations",   dim:"S" },
    { w:"I carefully assess all risks before committing to any course of action", dim:"C" },
  ]},
  { id:11, words:[
    { w:"I address disagreements directly and expect clear resolution",       dim:"D" },
    { w:"I try to keep the atmosphere positive, even when there is conflict", dim:"I" },
    { w:"I work hard to find solutions that everyone can accept",             dim:"S" },
    { w:"I rely on facts and clear evidence to resolve disagreements",        dim:"C" },
  ]},
  { id:12, words:[
    { w:"I am motivated by achieving visible, tangible results",              dim:"D" },
    { w:"I appreciate being recognised and praised for my contributions",     dim:"I" },
    { w:"I am motivated by knowing that my work is genuinely valued",         dim:"S" },
    { w:"I am motivated by producing work that meets the highest standard",   dim:"C" },
  ]},
  { id:13, words:[
    { w:"I focus on the end goal and work backwards from it",                 dim:"D" },
    { w:"I prefer flexible plans that allow for creative adjustment",         dim:"I" },
    { w:"I like to follow a clear, established process",                      dim:"S" },
    { w:"I create detailed plans and monitor them carefully",                 dim:"C" },
  ]},
  { id:14, words:[
    { w:"I contribute most by setting direction and driving results",         dim:"D" },
    { w:"I bring enthusiasm and positive energy to any team",                 dim:"I" },
    { w:"I contribute by being a reliable, supportive team member",           dim:"S" },
    { w:"I contribute by maintaining quality and attention to detail",        dim:"C" },
  ]},
  { id:15, words:[
    { w:"I make decisions confidently and move on quickly",                   dim:"D" },
    { w:"I include others in decisions to build enthusiasm and buy-in",       dim:"I" },
    { w:"I make decisions carefully, considering the impact on people",       dim:"S" },
    { w:"I make decisions based on thorough research and solid evidence",     dim:"C" },
  ]},
  { id:16, words:[
    { w:"I am comfortable with authority and personal accountability",        dim:"D" },
    { w:"I prefer to influence through relationships rather than rank",       dim:"I" },
    { w:"I work well within defined roles and clear expectations",            dim:"S" },
    { w:"I respect expertise and well-defined processes",                     dim:"C" },
  ]},
  { id:17, words:[
    { w:"I focus on results — new approaches only interest me if they work",  dim:"D" },
    { w:"I enjoy generating new ideas and exploring what is possible",        dim:"I" },
    { w:"I prefer improvements that are practical and proven",                dim:"S" },
    { w:"I evaluate new approaches rigorously before adopting them",          dim:"C" },
  ]},
  { id:18, words:[
    { w:"I thrive in competitive, high-performance environments",             dim:"D" },
    { w:"I work best in social, collaborative, energetic environments",       dim:"I" },
    { w:"I prefer stable, harmonious, predictable working environments",      dim:"S" },
    { w:"I work best in organised, quality-focused environments",             dim:"C" },
  ]},
  { id:19, words:[
    { w:"I prefer direct, honest feedback without lengthy explanation",       dim:"D" },
    { w:"I appreciate positive feedback and genuine encouragement",           dim:"I" },
    { w:"I value feedback that is warm, considered and personally delivered", dim:"S" },
    { w:"I want specific, evidence-based feedback on my work",                dim:"C" },
  ]},
  { id:20, words:[
    { w:"I influence others through confidence and clear authority",          dim:"D" },
    { w:"I influence others through enthusiasm and personal connection",      dim:"I" },
    { w:"I influence others through patience and building deep trust",        dim:"S" },
    { w:"I influence others through expertise and accurate information",      dim:"C" },
  ]},
  { id:21, words:[
    { w:"I prioritise results above all else",                                dim:"D" },
    { w:"I prioritise relationships and team engagement",                     dim:"I" },
    { w:"I prioritise stability, consistency and harmony",                    dim:"S" },
    { w:"I prioritise quality, accuracy and doing things correctly",          dim:"C" },
  ]},
  { id:22, words:[
    { w:"I learn best by diving in and figuring things out as I go",         dim:"D" },
    { w:"I learn best through conversation, collaboration and exploration",   dim:"I" },
    { w:"I learn best through structured, patient, step-by-step guidance",   dim:"S" },
    { w:"I learn best by researching thoroughly and understanding deeply",    dim:"C" },
  ]},
  { id:23, words:[
    { w:"I set aggressive, ambitious goals for myself",                       dim:"D" },
    { w:"I am energised by exciting, people-focused goals",                   dim:"I" },
    { w:"I set realistic, achievable goals and work steadily toward them",    dim:"S" },
    { w:"I set precise, measurable goals with clear success criteria",        dim:"C" },
  ]},
  { id:24, words:[
    { w:"I push people around me to work faster and deliver more",           dim:"D" },
    { w:"I energise others and get them genuinely excited about the work",    dim:"I" },
    { w:"I support others patiently and help them work at their own pace",    dim:"S" },
    { w:"I help others improve the quality and accuracy of their work",       dim:"C" },
  ]},
  { id:25, words:[
    { w:"For me, success means achieving ambitious results and winning",      dim:"D" },
    { w:"For me, success means making a positive impact on people",          dim:"I" },
    { w:"For me, success means being trusted, reliable and consistent",       dim:"S" },
    { w:"For me, success means producing work that meets the highest standard", dim:"C" },
  ]},
  { id:26, words:[
    { w:"I am direct and get straight to the point",                         dim:"D" },
    { w:"I am expressive and enthusiastic when I communicate",               dim:"I" },
    { w:"I am calm, measured and considerate when I communicate",            dim:"S" },
    { w:"I am precise and thorough when I communicate",                      dim:"C" },
  ]},
  { id:27, words:[
    { w:"I value results, accountability and the freedom to lead",           dim:"D" },
    { w:"I value connection, recognition and the chance to inspire others",  dim:"I" },
    { w:"I value security, genuine appreciation and long-term relationships", dim:"S" },
    { w:"I value accuracy, quality and clearly defined standards",           dim:"C" },
  ]},
  { id:28, words:[
    { w:"I am comfortable making unpopular decisions when they are right",   dim:"D" },
    { w:"I find it natural to read the mood of a room and respond to it",    dim:"I" },
    { w:"I am the person others come to when they need steady support",      dim:"S" },
    { w:"I notice errors and inconsistencies that others tend to miss",      dim:"C" },
  ]},
];

export const DISC_DIMS = {
  D:{ label:"Dominance",        icon:"🔴", color:"#C62828", light:"#FFEBEE",
      tagline:"Results-driven and decisive",
      keywords:["Direct","Decisive","Determined","Driving","Demanding","Daring"],
      desc:"D styles are direct, decisive and results-oriented. They thrive on challenge and authority. Motivated by power, accomplishment and status." },
  I:{ label:"Influence",        icon:"🟡", color:"#E8A020", light:"#FFFDE7",
      tagline:"Enthusiastic and people-oriented",
      keywords:["Enthusiastic","Optimistic","Collaborative","Persuasive","Inspiring"],
      desc:"I styles are enthusiastic, optimistic and relationship-oriented. They influence through charm and persuasion. Motivated by social recognition and collaboration." },
  S:{ label:"Steadiness",       icon:"🟢", color:"#2E7D32", light:"#E8F5E9",
      tagline:"Patient, loyal and consistent",
      keywords:["Patient","Reliable","Loyal","Steady","Supportive","Diplomatic"],
      desc:"S styles are patient, stable and people-oriented. They provide consistency and support. Motivated by security, cooperation and genuine appreciation." },
  C:{ label:"Conscientiousness",icon:"🔵", color:"#1565C0", light:"#E3F2FD",
      tagline:"Accurate, analytical and systematic",
      keywords:["Accurate","Analytical","Systematic","Careful","Principled"],
      desc:"C styles are analytical, systematic and quality-focused. They excel at precision and process. Motivated by accuracy, quality and correct procedures." },
};
